// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__34Fg8","buttons":"RemoveExpirationActionButtons_buttons__2aaw-"};